import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Button, Typography} from '@material-ui/core';
import ReactsCard from "../components/ui/ReactsCard";
import {ReportFormat, SubscriptionsExpirationRequest} from "../models/report.model";
import {downloadSubscriptionsExpiration} from "../api/reporting-functions";
import {downloadFile} from "../utils/function-util";
import Grid from "@material-ui/core/Grid";
import {DatePicker} from "@material-ui/pickers";
import {isBefore, addYears} from "date-fns";
import withReportDownloadComponentStyle from "../components/ui/styles/StyledReportDownloadComponent";

const SubscriptionExpirationReport: React.FC = ({classes}: any) => {
    const {t} = useTranslation();
    const firstAvailableDate = new Date(2021, 0, 1)
    const [startDate, handleStartDateChange] = useState<Date | null>(new Date());
    const [endDate, handleEndDateChange] = useState<Date | null>(new Date());
    let maxEndDate = addYears(startDate ?? new Date(), 1);

    const downloadStats = async () => {
        if (!startDate || !endDate)
            return;

        const request: SubscriptionsExpirationRequest = {
            format: ReportFormat.SPREADSHEET,
            startDate: startDate,
            endDate: endDate
        }
        const {blob, filename} = await downloadSubscriptionsExpiration(request);
        downloadFile(blob, filename);
    };

    const handleStartDate = (newStartDate: Date | null) => {
        handleStartDateChange(newStartDate);
        if (endDate && newStartDate && isBefore(endDate, newStartDate)) {
            handleEndDateChange(newStartDate);
        }
    }

    return (
        <ReactsCard title={t('SubscriptionsExpiration.Title')} className={classes.root}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="subtitle1">
                        {t('SubscriptionsExpiration.Paragraph')}
                    </Typography>
                </Grid>
                <Grid className={classes.dates} container item xs={12} md={9} lg={6} alignItems="center">
                    <Grid item xs={4}>
                        <DatePicker
                            required
                            views={["year", "month"]}
                            openTo="year"
                            format="MM/yyyy"
                            label={t("_Common.Labels.StartDate")}
                            minDate={firstAvailableDate}
                            value={startDate}
                            onChange={handleStartDate}
                        />
                    </Grid>

                    <Grid item xs={4}>
                        <DatePicker
                            required
                            views={["year", "month"]}
                            openTo="year"
                            format="MM/yyyy"
                            label={t("_Common.Labels.EndDate")}
                            minDate={startDate}
                            maxDate={maxEndDate}
                            value={endDate}
                            onChange={handleEndDateChange}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <Button variant="contained" color="primary" size="medium"
                                onClick={downloadStats}>
                            {t('SubscriptionsExpiration.DownloadReport')}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </ReactsCard>
    )
};

export const StyleSubscriptionExpirationReport = withReportDownloadComponentStyle(SubscriptionExpirationReport);
